const Us = () => {
  return (
    <>
      <div className="container-nosotros" id="nosotros">
        <h3 className="title-nosotros text-gray-700" style={{fontSize: '2rem'}}>NOSOTROS</h3>
        <div className="content-nosotros">
          AMSM fue constituida por los médicos de Clínica Santa María con el propósito de promover y
          desarrollar servicios relacionados a la profesión médica, para fortalecer su vinculación con la
          Clínica y entidades relacionadas con las prestaciones de salud efectuadas por los asociados a sus
          pacientes.
        </div>
      </div>

      <div className="container-nostros-detalles">
        <div className="row">
          <div className="col-md-4">
            <h3 className="mision-title text-gray-700">
              Nuestra Misión
            </h3>
            <div className="mision-descripcion" id="mision-descripcion">
              Somos la agrupación de los médicos staff de Clínica Santa María, nuestra misión es representar a sus asociados, gestionando los procesos de valorización y recaudación de sus honorarios médicos en forma eficiente y con alta calidad de servicio, procurando mejorar el bienestar y desarrollo de su actividad médica.
            </div>
          </div>
          <div className="col-md-4">
            <h3 className="organizacion-title text-gray-700">
              Nuestra Organización
            </h3>
            <div className="organizacion-descripcion">
              PRESIDENTE: Dr. Jaime Prado A.
              <br /><br />
              VICEPRESIDENTE: Dr. Iñaki Zarraonandia
              <br /><br />
              DIRECTORES: Dr. Felipe Corvalán, Dr. Fernando Vargas, Dra. María Isabel Domínguez
            </div>
          </div>
          <div className="col-md-4">
            <h3 className="administracion-title text-gray-700">
              Administración
            </h3>
            <div className="administracion-descripcion">
              GERENTE: Jorge Zúñiga
              <br /><br />
              RELACIONES MEDICAS: Paula Rodriguez
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Us